import { useState, useEffect } from 'react';
import IgnoredWordsService from '../../../../service/index';

export const DEFAULT_PAGE_SIZE = 10;

export const useFetch = (id, query, page) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [refetchIndex, setRefetchIndex] = useState(0);
  const [quantity, setQuantity] = useState(0);

  useEffect(() => {
    if (!id) return;

    (async () => {
      setLoading(true);
      try {
        const response = await IgnoredWordsService.getById(id);
        const wordsList =
          response.data.data?.words || response.data?.words || [];

        const filteredWords = wordsList.filter((word) =>
          word.toLowerCase().includes(query.toLowerCase())
        );

        const start = (page - 1) * DEFAULT_PAGE_SIZE;
        const paginatedWords = filteredWords.slice(
          start,
          start + DEFAULT_PAGE_SIZE
        );

        setData(
          paginatedWords.map((word, index) => ({
            id: `${index}-${word}`,
            word
          }))
        );
        setQuantity(filteredWords.length);
      } catch (error) {
        setError(true);
        setErrorMessage(
          error.response?.data?.message || 'Erro ao listar palavras ignoradas!'
        );
      } finally {
        setLoading(false);
      }
    })();
  }, [id, query, page, refetchIndex]);

  const refetch = () =>
    setRefetchIndex((prevRefetchIndex) => prevRefetchIndex + 1);

  return { data, quantity, loading, error, errorMessage, refetch };
};
